<template>
  <div class="fixed-salva-ricerca">
    <div class="salva-ricerca d-none d-xl-block d-lg-block">
      <h3><i class="fa fa-heart"></i> Salva ricerca e ricevi annunci</h3>
      <h5>Ti invieremo annunci compatibili con la tua ricerca. Per salvarla devi selezionare almeno una zona.</h5>

      <div class="form-group mb-0">
        <button
          class="search-button"
          data-gtm-event="click-salva-ricerca"
          @click="showModal()"
        >
          Salva la ricerca
        </button>
      </div>
    </div>

    <div class="salva-ricerca salva-ricerca-mobile d-lg-none">
      <button
        class="search-button"
        data-gtm-event="click-salva-ricerca"
        @click="showModal()"
      >
        <i class="fa fa-heart"></i>
        Salva la ricerca
      </button>
    </div>
  </div>
</template>

<script>
import Modal from '../../classes/modal.class';
export default {
  name: "SalvaRicercaButton",
  props: ['ricerca'],
  methods: {
    showModal () {
      const modal = new Modal({
        name: 'salva_ricerca',
        class: 'big-modal',
        component: 'salva-ricerca-wizard',
        padding: false,
        closeButton: true,
        callback: () => { this.$modal.hide('salva_ricerca'); },
        bind: {
          ricerca: this.ricerca,
          source: 'pulsante-salva-ricerca',
        }
      });
      this.$root.pushModal(modal);
    }
  }
}
</script>

<style lang="scss" scoped>
.salva-ricerca-mobile {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  padding: 5px !important;

}
</style>